module.exports = __webpack_public_path__ + "f8605a0f533a09db3b56a3e1228b0ab1.pdf";